<div class="filter app-filter-search-container">
  <mat-label class="mat-label">{{ filter.name }}</mat-label>
  <mat-form-field>
    <input matInput placeholder="{{ filter.name }}" [value]="(filter.value ? filter.value : '')" (input)="searchTerm.next($event.target.value)" autocomplete="off">
    <button mat-button matSuffix mat-icon-button aria-label="Clear">
      <mat-icon class="search-icon" svgIcon="search"></mat-icon>
    </button>
  </mat-form-field>
</div>
